/**
 * Recurly/Avalara: a 5-digit US ZIP is enough for tax. ZIP+4 must be 12345-6789.
 * https://support.recurly.com/hc/en-us/articles/360039404432-What-does-the-invalid-address-error-mean
 */
export const US_POSTAL_CODE_MAX_LENGTH = 10;
export const US_POSTAL_CODE_PATTERN = /^\d{5}(-\d{4})?$/;

/** A1A 1A1 */
export const CA_POSTAL_CODE_MAX_LENGTH = 7;
export const CA_POSTAL_CODE_PATTERN = /^[A-Z]\d[A-Z] \d[A-Z]\d$/;

export const RECURLY_POSTAL_CODE_MAX_LENGTH = 11;

const US_ZIP_MAX_DIGITS = 9;
const CA_POSTAL_CODE_ALNUM_LENGTH = 6;

export const formatBillingPostalCode = (value: string, countryCode?: string | null): string => {
  const country = countryCode?.toUpperCase();

  if (country === 'US') {
    const digits = value.replace(/\D/g, '').slice(0, US_ZIP_MAX_DIGITS);
    if (digits.length <= 5) {
      return digits;
    }

    return `${digits.slice(0, 5)}-${digits.slice(5)}`;
  }

  if (country === 'CA') {
    const alnum = value
      .toUpperCase()
      .split('')
      .reduce<string[]>((acc, char) => {
        if (acc.length >= CA_POSTAL_CODE_ALNUM_LENGTH) {
          return acc;
        }

        const pattern = acc.length % 2 === 0 ? /[A-Z]/ : /\d/;
        return pattern.test(char) ? acc.concat(char) : acc;
      }, []);

    if (alnum.length <= 3) {
      return alnum.join('');
    }

    return `${alnum.slice(0, 3).join('')} ${alnum.slice(3).join('')}`;
  }

  return value.slice(0, RECURLY_POSTAL_CODE_MAX_LENGTH);
};
